import { observer } from 'mobx-react'
import React, { useMemo, useState } from 'react'
import LoadingSpinner from '../../Components/LoadingSpinner'
import Table from '../../Components/Table'
import ReportCollection from '../../State/Collections/ReportCollection'
import SessionStore from '../../State/SessionStore'
import RenderOnQueries from '../Layout/RenderOnQueries'
import UpdateReportModal from '../../Components/UpdateReportModal'
import { trpc } from '../../system/trpc'
import { processTRPCData } from '../../Queries/fetchData'
import { format } from 'date-fns'
import { dateStringLookup } from '../../Components/Filters'

export default observer(({ id }) => {
    const report =
        ReportCollection.reportsById[id] ||
        SessionStore.organisation.defaultInvoiceReport
    const [queryData, setQueryData] = useState([])
    return (
        <RenderOnQueries
            key={report.queryKey}
            loading={<LoadingSpinner />}
            queryIds={[
                {
                    id: 'invoiceReport' + report.queryKey,
                    cacheTime: 5000,
                    staleTime: 5000,
                    queryFn: async () => {
                        const data =
                            await trpc.invoiceReport.getReportsData.query({
                                columns: report.columns.filter(
                                    (c) =>
                                        !report.columnOptionsById[c]
                                            ?.permissions ||
                                        report.columnOptionsById[
                                            c
                                        ].permissions()
                                ),
                                filters: report.filters.map((f) => {
                                    if (
                                        report.columnOptionsById[f.column]
                                            ?.type === 'date'
                                    ) {
                                        let value =
                                            dateStringLookup[f.value]?.() ||
                                            f.value
                                        if (Array.isArray(value)) {
                                            value = value.map((d) =>
                                                d
                                                    ? format(d, 'yyyy-MM-dd')
                                                    : null
                                            )
                                        } else {
                                            value = value
                                                ? format(value, 'yyyy-MM-dd')
                                                : null
                                        }
                                        return {
                                            ...f,
                                            value,
                                        }
                                    } else {
                                        return f
                                    }
                                }),
                                groupBy: [],
                                sortBy: report.sortBy || [],
                                dateRange: report.dateRange.map((d) =>
                                    isFinite(d) ? format(d, 'yyyy-MM-dd') : null
                                ),
                                invoiceDateType:
                                    SessionStore.settings.reportInvoiceDateType,
                            })
                        setQueryData(processTRPCData(data))
                        return queryData
                    },
                },
            ]}
        >
            <UpdateReportModal report={report} />
            {!report?.needsUpdate ? (
                <InvoiceListTable report={report} queryData={queryData} />
            ) : null}
        </RenderOnQueries>
    )
})

const InvoiceListTable = observer(({ report, queryData }) => {
    const rows = useMemo(() => {
        const rowData = []
        queryData?.forEach((invoice) => {
            delete invoice.id
            if (
                (invoice.ref &&
                    invoice.ref
                        .toLowerCase()
                        .includes(report.searchFilter.toLowerCase())) ||
                (invoice.project &&
                    invoice.project
                        .toLowerCase()
                        .includes(report.searchFilter.toLowerCase()))
            ) {
                rowData.push(invoice)
            }
        })
        return rowData
    }, [queryData, report.searchFilter])
    return (
        <Table
            key={report.queryKey}
            tableStore={report.tableStore}
            columns={report.tableColumns}
            rows={rows}
            sortBy={[
                ['issuedOn', 'desc'],
                ['description', 'desc'],
            ]}
            showTotals={true}
        />
    )
})
